export default __webpack_public_path__ + "static/media/am5.b96b1be5.jpg";